interface LinkHTML {
  __html: string
}

function create_link_html(
  link_to_id: string,
  link_text: string | number
): LinkHTML {
  const scrollBehaviour =
    "window.scrollTo({behavior: element ? 'smooth' : 'auto', top: element ? element.offsetTop : 0})"
  return {
    __html: `<a href="javascript:element = document.getElementById('${link_to_id}'); ${scrollBehaviour}">
      ${link_text}</a>`,
  }
}

export function Superscript({ id }: { id: string | number }) {
  const link_to_id = `footnote-${id}`
  return (
    <sup
      id={`superscript-${id}`}
      dangerouslySetInnerHTML={create_link_html(link_to_id, id)}
    ></sup>
  )
}

export function Footnote({ id }: { id: string | number }) {
  const link_to_id = `superscript-${id}`
  return (
    <sup
      id={`footnote-${id}`}
      dangerouslySetInnerHTML={create_link_html(link_to_id, id)}
    ></sup>
  )
}

export function ScrollBackToSuperscript({ id }: { id: string | number }) {
  const link_to_id = `superscript-${id}`
  return (
    <span dangerouslySetInnerHTML={create_link_html(link_to_id, '↩')}></span>
  )
}
